import Badge from "../../../components/ui/Badge";
import { cx } from "../../../utils/classNames";
import styles from "../Performance.module.css";

const SAVE_LABELS = {
  idle: "",
  pending: "Unsaved changes…",
  saving: "Saving…",
  saved: "Saved ✓",
  error: "Couldn't save. Your changes are kept.",
};

// Sticky live score while rating. `scores` comes from the latest save response.
const ScoreBar = ({ scores, saveStatus, onRetry }) => (
  <div className={styles.scoreBar}>
    {scores ? (
      <>
        {scores.sections.map((s) => (
          <span key={s.key} className={styles.scorePart} title={s.title}>
            {s.title.replace(/^Part [IVX]+ – /, "")}: <strong>{s.score}</strong>{" "}
            / {s.weight}
            <span className="ms-1">
              ({s.rated}/{s.totalItems})
            </span>
          </span>
        ))}
        <span className={styles.scoreTotal}>
          {scores.total} / 100{" "}
          {scores.band && <Badge tone="blue">{scores.band}</Badge>}
        </span>
      </>
    ) : (
      <span className={styles.scorePart}>Rate items to see the score.</span>
    )}

    {saveStatus && (
      <span
        className={cx(
          styles.saveStatus,
          saveStatus === "error" && styles.saveError,
        )}
      >
        {SAVE_LABELS[saveStatus]}
        {saveStatus === "error" && onRetry && (
          <button
            type="button"
            className="btn btn-link btn-sm p-0 ms-2"
            onClick={onRetry}
          >
            Retry
          </button>
        )}
      </span>
    )}
  </div>
);

export default ScoreBar;
